import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: any) => {
  return {
    modal: {
      maxWidth: "760px",
    },
    headerIcon: {
      backgroundColor: "#FEDF89",
      height: 40,
      width: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: 16,
    },
    leaveTitle: {
      display: "flex",
      alignItems: "center",
      marginBottom: 16,
    },
    warningIcon: {
      color: "#F79009",
      fontSize: "28px !important",
    },
    title: {
      font: "400 16px/24px Inter",
      color: "#232325",
      marginBottom: 8,
    },
    warning: {
      font: "italic 400 16px/24px Inter",
      color: "#F79009",
    },
  };
});

export default styles;
